import React, { FC } from 'react'
import { Route, Redirect, RouteComponentProps } from 'react-router-dom'
import { isEmpty, isNil } from 'lodash'

import CONFIG from '../config'
import { COOKIE_TFF } from '../constants/auth-constants'
import { SessionData, SessionDataNoBID } from '../types/interface/session.interface'
import { FSMRouterConsumer } from '../FSM'
import { getSessionStorageAuthData } from '../service/util.service'
import getCookieByName from '../util/getCookieByName'

export interface RouteComponent {
  path: string
  component: React.ComponentType<RouteComponentProps> | React.ComponentType
}

export interface FSMProtectedRouteProps extends RouteComponent {
  routes?: RouteComponent[]
}

const FSMProtectedRoute: FC<FSMProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const isTFF = getCookieByName(COOKIE_TFF).includes('true')
  const parsedUserInfo: SessionData = getSessionStorageAuthData(CONFIG.USER_INFO_KEY)
  const parsedUserInfoBID: SessionData = getSessionStorageAuthData(CONFIG.USER_INFO_KEY_BID)

  const isAuthenticated: boolean = !!parsedUserInfo && !!(parsedUserInfo as SessionDataNoBID).token
  const isAuthenticatedBID: boolean = !isEmpty(parsedUserInfoBID) && !isNil(parsedUserInfoBID.token)

  const isAuthorized = isAuthenticated || isTFF || isAuthenticatedBID

  return (
    <FSMRouterConsumer>
      {(context) => {
        return (
          <Route
            exact
            {...rest}
            render={(props: RouteComponentProps) => {
              if (isAuthorized) {
                return <Component {...props} {...{ send: context.service.send }} />
              }

              //FIXME: Redirected us back to /auth every time: getRedirectPath(protectSrc)
              //FIXME: Better to return null
              return <Redirect to='/' />
            }}
          />
        )
      }}
    </FSMRouterConsumer>
  )
}

export default FSMProtectedRoute
